<template>
  <v-row align="center" class="my-1">
    <v-col :cols="rowAlign ? 12 : 5" class="py-0">
      <p class="my-0 caption">{{ name }}</p>
    </v-col>
    <v-col :cols="rowAlign ? 9 : 6" class="py-1">
      <v-progress-linear
        rounded
        height="5"
        :value="value * 20"
      ></v-progress-linear>
    </v-col>
    <v-col cols="1" class="py-1">
      <strong
        class="primary--text"
        v-if="isShowValue"
        style="white-space: nowrap"
        >{{ value }}</strong
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["name", "value", "rowAlign", "isShowValue"],
  data() {
    return {};
  },
  methods: {},
};
</script>
